import { USER_API_ENDPOINTS } from "@/features/auth/config/userApiPath";
import { fetcher } from "@/shared/lib/fetcher.client";
import type { UserResponse } from "@/shared/types/";

export const getMe = async (): Promise<UserResponse> => {
  const response = await fetcher.get<UserResponse>(USER_API_ENDPOINTS.ME);
  return response.data;
};

export const confirmUserActivity = async (): Promise<UserResponse> => {
  const response = await fetcher.get<UserResponse>(USER_API_ENDPOINTS.ME);
  return response.data;
};
